import { render, staticRenderFns } from "./zbDemandList.vue?vue&type=template&id=0c9622d9&scoped=true"
import script from "./zbDemandList.vue?vue&type=script&lang=js"
export * from "./zbDemandList.vue?vue&type=script&lang=js"
import style0 from "./zbDemandList.vue?vue&type=style&index=0&id=0c9622d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9622d9",
  null
  
)

export default component.exports